import React, { useEffect, useState } from 'react';
import { api } from '../../context/AuthContext';
import { Coins, CalendarBlank } from '@phosphor-icons/react';

const money = (v) => `€${Number(v || 0).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const shortDate = (v) => (v ? new Date(v).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }) : 'Date to be confirmed');

/** Investor payout view: what has been received and what is still expected. */
export const PayoutHistory = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get('/portfolio/v2/distributions')
      .then((res) => setData(res.data))
      .catch(() => setData(null));
  }, []);

  if (!data || (data.distributions || []).length === 0) return null;

  return (
    <section data-testid="payout-history">
      <div className="flex items-baseline justify-between gap-4">
        <h2 className="text-base md:text-lg font-heading">Distributions &amp; payouts</h2>
        <p className="text-xs text-foreground-muted tabular-nums">
          {money(data.received_total)} received
          {data.expected_total > 0 && ` · ${money(data.expected_total)} expected`}
        </p>
      </div>

      {data.next_payment && (
        <div
          className="mt-3 rounded-2xl border border-primary/25 bg-primary/[0.06] px-5 py-4 flex items-center gap-3"
          data-testid="next-payment-card"
        >
          <CalendarBlank size={18} className="text-primary flex-shrink-0" weight="duotone" />
          <div className="min-w-0">
            <p className="text-[11px] uppercase tracking-[0.16em] text-primary font-medium">Next expected payment</p>
            <p className="text-sm mt-0.5 tabular-nums">
              {money(data.next_payment.outstanding)} · {data.next_payment.project_title || data.next_payment.distribution_code}
              {' · '}{shortDate(data.next_payment.payment_date)}
            </p>
          </div>
        </div>
      )}

      <div className="mt-3 bg-white rounded-2xl border border-black/[0.05] divide-y divide-black/[0.05]">
        {data.distributions.map((d) => (
          <div key={d.id} className="px-5 py-3.5 flex items-center justify-between gap-4" data-testid={`payout-row-${d.id}`}>
            <div className="min-w-0 flex items-start gap-3">
              <Coins size={17} className="text-foreground-muted mt-0.5 flex-shrink-0" weight="duotone" />
              <div className="min-w-0">
                <p className="text-sm font-medium truncate">{d.project_title || d.distribution_code}</p>
                <p className="text-xs text-foreground-muted capitalize">
                  {(d.distribution_type || '').replace(/_/g, ' ')} · {shortDate(d.payment_date)}
                </p>
              </div>
            </div>
            <div className="text-right flex-shrink-0">
              <p className="text-sm font-medium tabular-nums">{money(d.amount)}</p>
              <p className="text-xs text-foreground-muted">
                {d.outstanding > 0 ? `${money(d.outstanding)} expected` : 'Paid'}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default PayoutHistory;
